import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import {
  Section,
  Button,
  MediaQuery,
  EmailSignup,
  WorkFlow,
  CallToActionBanner,
  CrewImages,
  AnimationWrapper,
  SelectedUseCase
} from '..'
import * as styles from './styles'
import placeholder1 from '../../../assets/placeholder1.svg'
import system15Animation from '../../lottie-animations/system-08v1.json'
import system17Animation from '../../lottie-animations/system-17v2.json'
import variables from '../../styles/variables'

const propTypes = {
  data: PropTypes.shape({
    allYaml: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({
        node: PropTypes.shape({
          carouselHeader: PropTypes.string,
          mainPointsHeader: PropTypes.string,
          mainPointsSection1Header: PropTypes.string,
          mainPointsSection1Tagline: PropTypes.string,
          mainPointsSection2Header: PropTypes.string,
          mainPointsSection2Tagline: PropTypes.string,
          mainPointsSection3Header: PropTypes.string,
          mainPointsSection3Tagline: PropTypes.string,
          mainPointsButtonText: PropTypes.string,
        }),
      })),
    })
  }).isRequired
}

export default function IndexContent({ data }) {
  return (
    <Section>
      <styles.Container>
        <styles.SelectedUseCaseSection>
          <styles.SelectedUseCaseHeader>Selected use case</styles.SelectedUseCaseHeader>
          <Section>
            <SelectedUseCase />
          </Section>
        </styles.SelectedUseCaseSection>

        <WorkFlow />

        <styles.MainPointsContainer>
          <styles.MainPointsSection>
            <styles.MainPointsHeader>{data.mainPointsHeader}</styles.MainPointsHeader>
            <Section>
              <styles.MainPointItemRow>
                <styles.MainPointItemCol sm={6} xs={12}>
                  <styles.MainPointsSectionHeader>
                    {data.mainPointsSection1Header}
                  </styles.MainPointsSectionHeader>
                  <styles.MainPointsTagline>
                    {data.mainPointsSection1Tagline}
                  </styles.MainPointsTagline>
                </styles.MainPointItemCol>
                <styles.MainPointItemCol sm={6} xs={12}>
                  <styles.MainPointColCenterer>
                    <styles.MainPointAnimation>
                      <AnimationWrapper
                        animation={system15Animation}
                        pauseAt={2.3}
                        animationSpeed={0.7}
                      />
                    </styles.MainPointAnimation>
                  </styles.MainPointColCenterer>
                </styles.MainPointItemCol>
              </styles.MainPointItemRow>
              <styles.MainPointItemRow reverse>
                <styles.MainPointItemCol sm={6} xs={12}>
                  <styles.MainPointsSectionHeader>
                    {data.mainPointsSection2Header}
                  </styles.MainPointsSectionHeader>
                  <styles.MainPointsTagline>
                    {data.mainPointsSection2Tagline}
                  </styles.MainPointsTagline>
                </styles.MainPointItemCol>
                <styles.MainPointItemCol sm={6} xs={12}>
                  <styles.MainPointColCenterer>
                    <styles.MainPointImageContainer>
                      <styles.MainPointGraphicBackground src={placeholder1} alt="polaroid_background" />
                      <styles.MainPointPolaroidImage src="https://s3.eu-central-1.amazonaws.com/aitoai-public/website-assets/polaroid.jpg" alt="polaroid" />
                    </styles.MainPointImageContainer>
                  </styles.MainPointColCenterer>
                </styles.MainPointItemCol>
              </styles.MainPointItemRow>
              <styles.MainPointItemRow>
                <styles.MainPointItemCol sm={6} xs={12}>
                  <styles.MainPointsSectionHeader>
                    {data.mainPointsSection3Header}
                  </styles.MainPointsSectionHeader>
                  <styles.MainPointsTagline>
                    {data.mainPointsSection3Tagline}
                  </styles.MainPointsTagline>
                </styles.MainPointItemCol>
                <styles.MainPointItemCol sm={6} xs={12}>
                  <styles.MainPointColCenterer>
                    <styles.MainPointAnimation>
                      <AnimationWrapper animation={system17Animation} animationSpeed={0.7} />
                    </styles.MainPointAnimation>
                  </styles.MainPointColCenterer>
                </styles.MainPointItemCol>
              </styles.MainPointItemRow>
            </Section>
            <styles.MainPointsButton>
              <Link to="/product">
                <Button size="small">
                  {data.mainPointsButtonText}
                </Button>
              </Link>
            </styles.MainPointsButton>
          </styles.MainPointsSection>
        </styles.MainPointsContainer>
        <styles.CallToActionContainer>
          <Row>
            <Col sm={11} xs={12}>
              <CallToActionBanner
                smallHeader={data.indexBannerSmallHeader}
                header={data.indexBannerHeader}
                buttonTitle={data.indexBannerButton.text}
                linkText={data.indexBannerLink.text}
                buttonUrl={data.indexBannerButton.url}
                linkUrl={data.indexBannerLink.url}
                target="_blank"
              />
            </Col>
            <MediaQuery query={variables.media.md}>
              <Col sm={1}>
                <CrewImages />
              </Col>
            </MediaQuery>
          </Row>
        </styles.CallToActionContainer>
        <EmailSignup />
      </styles.Container>
    </Section>
  )
}

IndexContent.propTypes = propTypes
